import React, { useState, useEffect } from "react";
import locale from "../../_util/locale";
import CommonList from "./CommonList";

import MyGroupImg from "./assets/imgs/my-group.png";
import MyPartnerImg from "./assets/imgs/my-partner.png";
import RecentSessionImg from "./assets/imgs/recent-session.png";
import externalContactImg from "./assets/imgs/external-contact.png";
import MyOrgImg from "./assets/imgs/my-org.png";
import RecentForward from "./RecentForward";

import ByContactImg from "./assets/imgs/by-contact.png";
import BySessionImg from "./assets/imgs/by-session.png";
import ByOrgImg from "./assets/imgs/by-org.png";
import BatchImportImg from "./assets/imgs/batch-import.png";

import { IItemData } from "./common.typing";

export interface IHomeProps {
    /** 组件类型：
     * - 选人：member
     * - 选群：group
     * - 选会话：session
     * - 选组织架构：org
     * - default：member
     */
    type?: string;
    /** 是否展示【我的群组】入口，默认为 false */
    showGroups?: boolean;
    /** 是否展示【最近会话】入口，默认为 false */
    showRecentSession?: boolean;
    /** 是否展示【组织架构】入口，默认为 true */
    showOrganization?: boolean;
    showPartner?: boolean;
    /** 是否展示【外部联系人】入口，默认为 false */
    showExternalContact?: boolean;
    /** 按联系人的tab列表 */
    byContactTabList: any[];
    /** 按会话的tab列表 */
    bySessionTabList: any[];
    /** 是否有权限按照组织架构选人，默认为 all */
    authority?: string;
    /** 获取当前用户的组织架构信息，用于 home 页 */
    getPersonOrg?: () => void;
    /** 根据部门 id 获取组织架构信息 */
    // getOrgList: (id?: number) => void;
    getOrgList?: (obj?: IItemData, from?: string) => void;
    /** 组织架构展开信息 */
    /** 最近联系人 */
    recentConcactsList?: IItemData[];
    /** 当前已选 */
    currentList?: IItemData[];
    /** 最近转发列表 */
    recentForwardList?: IItemData[];
    /** 设置当前已选的 */
    setCurrentList: (list: IItemData[]) => void;
    /** 修改页面 */
    onChangeCurPage: (page: string) => void;
    /** 不可用 id，包括 group、user、session、org */
    // disabledids?: number[];
    disabledids?: string[];
    requiredList?: IItemData[];
    personOrg?: IItemData;

    /** 是否展示【批量导入】入口，默认为 false */
    showBatchImport?: boolean;
    /** 是否从组织架构开始选人，如超管 */
    orginSelect?: boolean;
    /** 是否展示最近转发 */
    showRecentForward?: boolean;
    /** 是否展示最近联系人 */
    isShowRecentConcacts?: boolean;
    /** 埋点方法 */
    track: (eventName: string, eventData?: any) => void;
    /** 组件的标题 */
    title?: string;
}

const Home: React.FC<IHomeProps> = ({
    type,
    showGroups = false,
    showRecentSession = false,
    showOrganization = true,
    showPartner = false,
    byContactTabList,
    bySessionTabList,
    authority = "all",
    getPersonOrg,
    getOrgList,
    recentConcactsList,
    currentList = [],
    setCurrentList,
    onChangeCurPage,
    disabledids,
    requiredList,
    personOrg,
    showExternalContact,
    showBatchImport,
    orginSelect,
    recentForwardList,
    showRecentForward = false,
    isShowRecentConcacts = false,
    track,
    title,
}) => {
    useEffect(() => {
        getPersonOrg && getPersonOrg();
    }, []);

    /**
     * 打开组织架构列表页
     * @param id 组织架构 id
     */
    const openOrgList = (v, from) => {
        // 根据当前组织架构 id 获取 orgList
        getOrgList && getOrgList(v, from);
        // 跳转到组织架构列表页
        onChangeCurPage("organization");
    };

    const allTitle = (
        <div className="alltitle">
            {/* 按联系人 */}
            {byContactTabList.length > 0 && (
                <div
                    className="title titleCom"
                    onClick={() => onChangeCurPage(byContactTabList[0].key)}
                >
                    <img src={ByContactImg} />
                    <span>{locale("by_contact")}</span>
                </div>
            )}
            {/* 按会话 */}
            {bySessionTabList.length > 0 && (
                <div
                    className="title titleCom"
                    onClick={() => onChangeCurPage(bySessionTabList[0].key)}
                >
                    <img src={BySessionImg} />
                    <span>{locale("by_session")}</span>
                </div>
            )}
            {/* 按组织架构 */}
            {(showOrganization || type === "org") && (
                <div
                    className="title titleCom"
                    onClick={() =>
                        (type !== "org" || authority != "all") && !orginSelect
                            ? openOrgList(personOrg, "")
                            : openOrgList(personOrg || {}, "top-level")
                    }
                >
                    <img src={ByOrgImg} />
                    <span>{locale("by_org")}</span>
                </div>
            )}
            {/* 批量导入 */}
            {showBatchImport && (
                <div
                    className="title titleCom"
                    onClick={() => onChangeCurPage("batchImport")}
                >
                    <img src={BatchImportImg} />
                    <span>{locale("by_batch_import")}</span>
                </div>
            )}
        </div>
    );

    // 最近联系人模块
    const recentConcacts = (
        <div className="commonConnect">
            <CommonList
                {...{
                    type: "member",
                    title: locale("useradd_recent_connect"),
                    list: recentConcactsList,
                    disabledids,
                    currentList,
                    setCurrentList,
                    requiredList,
                    isNeedTrack: true,
                    trackTitle: title,
                    track,
                }}
            />
        </div>
    );

    console.log("isShowRecentConcacts", isShowRecentConcacts);
    return (
        <div className="boxorgall">
            {allTitle}
            <div className="boxorgallContentBox">
                {showRecentForward && (
                    <RecentForward
                        {...{
                            currentList,
                            setCurrentList,
                            recentForwardList,
                            track,
                            title,
                        }}
                    />
                )}
                {isShowRecentConcacts && recentConcacts}
            </div>
        </div>
    );
};

export default Home;
